// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2xbQm","top":"Menu_top__2gHwG","bottom":"Menu_bottom__3BB0i"};